import index from './Tutorial'
export default index